import { FC, useState, useEffect } from "react";
import { Flex } from "@otrium/core";
import { PriceRange, PriceInputs, useRange } from "src/molecules/Range";
import {
  FilterContentWrapper,
  OutsideClickableWrapper,
} from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/DesktopFilter.styled";
import { ShowResults } from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/ShowResults";
import NoSSR from "src/atoms/NoSSR";

interface Props {
  min: number;
  max: number;
  currentRefinement: {
    min: number;
    max: number;
  };
  refine: ({ min, max }: { min: number; max: number }) => void;
  onClose: () => void;
  outerRef: React.RefObject<HTMLDivElement>;
}

const PriceFilter: FC<Props> = ({
  refine,
  currentRefinement,
  min = 0,
  max = 0,
  onClose,
  outerRef,
}) => {
  const floorMin = Math.floor(currentRefinement.min || 0);
  const ceilMax = Math.ceil(currentRefinement.max || 0);
  const [initialValue] = useState({
    min: floorMin,
    max: ceilMax,
  });
  const [filterApplied, setFilterApplied] = useState(false);
  const {
    onSliderChange,
    onBlurHandler,
    onInputChange,
    initialMinPrice,
    initialMaxPrice,
    range,
  } = useRange({
    priceFilter: { min: Math.floor(min), max: Math.ceil(max) },
    minPrice: floorMin,
    maxPrice: ceilMax,
    handleRange: ([start, end]) => {
      refine({ min: Math.max(start, min), max: Math.min(end, max) });
    },
  });

  useEffect(() => {
    setFilterApplied(
      !(
        Number(range[0]) === initialValue.min &&
        Number(range[1]) === initialValue.max
      )
    );
  }, [range]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <OutsideClickableWrapper handler={onClose} outerRef={outerRef}>
      <FilterContentWrapper mb={2}>
        <NoSSR>
          <Flex mb={2} alignItems="center">
            <PriceInputs
              range={range}
              onInputChange={onInputChange}
              onBlurHandler={onBlurHandler}
            />
          </Flex>
        </NoSSR>
        <PriceRange
          range={range}
          handleRange={([start, end]) =>
            refine({ min: Math.max(start, min), max: Math.min(end, max) })
          }
          onSliderChange={onSliderChange}
          initialMinPrice={initialMinPrice}
          initialMaxPrice={initialMaxPrice}
        />
      </FilterContentWrapper>

      <ShowResults hasFilters={filterApplied} onClick={onClose} />
    </OutsideClickableWrapper>
  );
};

export { PriceFilter };
